import styled from "styled-components";
import media from "../../static/style/media";

export const Container = styled.div`
  margin: 0 auto;
`;
export const ContentContainer = styled.div`
  width: 700px;
  padding: 20px 5px;
  height: 1000px;
  margin: 0 auto;
  ${media.small`
    padding: 0px 8px;
    width: 100%;
  `};
`;

export const ChartContainer = styled.div`
  height: 300px;
`;

export const SearchBtn = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  height: 50px;
  background-color: #ebecee;
  border: 1px solid #d8d8d8;
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background-color: #bddbff;
  }
`;
export const ListTitle = styled.div`
  font-weight: 600;
  font-size: 1.5rem;
  border-bottom: 3px solid black;
  padding-bottom: 15px;
  margin-bottom: 15px;
`;
